import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components/macro'
import {
  Button, Text, Clamp, Spacer
} from 'components/atoms'
import { refType } from 'types'

const FileInput = ({
  onChange,
  initialValue,
  initialName,
  innerRef,
  onBlur,
  onFocus,
  buttonText,
  ...props
}) => {
  const [file, setFile] = React.useState(initialValue)
  const inputRef = React.useRef(null)

  const handleChange = (e) => {
    const [newFile] = e.target.files
    setFile(newFile)
    onChange(newFile)
  }

  const handleUpload = (e) => {
    e.stopPropagation();
    if (inputRef && inputRef.current) {
      inputRef.current.click();
    }
  }

  return (
    <File ref={innerRef} onBlur={onBlur} onFocus={onFocus} onClick={handleUpload}>
      {file
        ? (
          <Button modifiers={['xsText']} icon="fal fa-file-alt" />
        )
        : (
          <Button modifiers={['xsText']}>
            {buttonText}
          </Button>
        )
      }
      <Spacer left="xs" />
      <Text modifiers={['light']}>
        <Clamp>
          {
            file && file.name
              ? file.name
              : initialName || 'nenhum ficheiro selecionado'
          }
        </Clamp>
      </Text>
      <input
        type="file"
        style={{ display: 'none' }}
        ref={inputRef}
        onChange={handleChange}
        {...props}
      />
    </File>
  )
}

FileInput.propTypes = {
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  initialValue: PropTypes.shape({
    name: PropTypes.string,
  }),
  innerRef: refType,
  initialName: PropTypes.string,
  buttonText: PropTypes.string,
}

FileInput.defaultProps = {
  onChange: () => {},
  onBlur: () => {},
  onFocus: () => {},
  initialValue: null,
  innerRef: null,
  initialName: undefined,
  buttonText: 'selecionar ficheiro'
}

const File = styled.div`
  display: flex;
  align-items: center;
  ${Text} {
    padding-bottom: 0px !important;
  }
`

export default FileInput
